import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './InvoiceDetail';
import InvoiceDetail from './InvoiceDetail';
import { StoreState } from 'src/store/reducers';
import { getInvoice, getFiles, signInvoiceDoc, getSigners } from 'src/store/actions/invoice-actions';
import { toast } from 'react-toastify';

function mapStateToProps(state: StoreState): StateProps {
    return {
        data: state.invoices.current,
        inProgress: state.invoices.inProgress,
        files: state.invoices.currentFiles,
        signedDocs: [],
        signers: state.invoices.signers,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (id: string) => dispatch(getInvoice(id)),
        getFiles: (id: string) => dispatch(getFiles(id)),
        getSigners: (id: string) => dispatch(getSigners(id)),
        setSignDoc: (id, files: any) =>
            dispatch(
                signInvoiceDoc(
                    id,
                    files,
                    () => {
                        toast.success('Invoice was successfully uploaded');
                    },
                    (err) => {
                        toast.error(err);
                    },
                ),
            ),
    };
}

const InvoiceDetailScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(InvoiceDetail);

export default InvoiceDetailScreen;
